export interface WellbeingHubCategory{
    key:string,
    title: string,
    image: number[],
    icon: string
}
export enum WellbeingHubCaetgory{
    webinars = "webinars",
    classes = "classes",
    wellbeing = "wellbeing",
    fitness = "fitness",
    nutrition = "nutrition",
    beCalm = "beCalm"
}